import React, { useEffect } from 'react'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import ChartColumn from '../../../../components/charts/ChartColumn'
import ChartColumnSkeleton from '../../../../components/skeletons/ChartColumnSkeleton'
import { ChartColumnThemes } from '../../../../components/charts/types/ChartColumn'
import { formatNumber } from '../../../../utils/Helpers'

const GET_DATA = gql`
  query PaymentsTypes {
    pharmaciesAggs(
      size: 0, 
      query: {
        bool: {
          filter: [
            {
              term: {
                status_name_keyword: "Online"
              }
            }
          ]
        }
      }, 
      aggs: {
        types: {
          terms: {
            field: "payment_service_type_desc.keyword",
            order: {
              _count: "desc"
            },
            size: 5
          }
        }
      }
    ) {
      aggregations
    }
  }
`

interface Bucket {
  key: string
  doc_count: number
}
const PaymentsTypes = (): JSX.Element => {
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_DATA, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData()
  }, [])

  if (networkStatus === NetworkStatus.refetch) return <ChartColumnSkeleton />
  if (loading || !data) return <ChartColumnSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.pharmaciesAggs.aggregations) return <p>No data found</p>

  const { buckets } = data.pharmaciesAggs.aggregations.types
  const categories: Array<string> = []
  const seriesData: Array<number> = []

  buckets.map((bucket: Bucket) => {
    categories.push(bucket.key)
    return seriesData.push(bucket.doc_count)
  })

  const options = {
    chart: {
      id: 'payments-types'
    },
    xaxis: {
      categories
    },
    grid: {
      show: false
    },
    plotOptions: {
      bar: {
        dataLabels: {
          position: 'top'
        }
      }
    },
    dataLabels: {
      formatter: (val: number) => {
        return formatNumber(val, 0)
      },
      style: {
        colors: ['#304758']
      }
    },
    tooltip: {
      y: {
        formatter: function (value: number, { series }: any) {
          const valuesSum = series[0].reduce((sum: number, val: number) => val + sum, 0)
          return `${formatNumber((value / valuesSum) * 100, 2)} %`
        }
      }
    }
  }
  const series = [{
    name: 'Percentual',
    data: seriesData
  }]

  return <Paper elevation={2}>
    <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>Bandeiras de cartão de crédito</Typography>
    <ChartColumn options={options} series={series} theme={ChartColumnThemes.blue} height={320} />
  </Paper>
}

export default PaymentsTypes
